@if (tooltip() && tooltip() !== '-') {
  <div
    class="tooltip force-visible table-tooltip"
    [ngClass]="position()"
  >
    {{ tooltip() | translate }}
    <div class="tooltip-arrow"></div>
  </div>
}
